import React, { useState } from "react";

function GameGallery({ images }) {
  const [activeImage, setActiveImage] = useState(images[0]);

  if (!images || images.length === 0) return null;

  return (
    <div className="game-gallery">
      {/* Image Principale */}
      <div className="main-image-container">
        <img src={activeImage} alt="Screenshot principal" className="main-image" />
      </div>

      {/* Miniatures */}
      <div className="thumbnails-grid">
        {images.map((img, index) => (
          <div 
            key={index} 
            className={`thumbnail ${activeImage === img ? "active" : ""}`}
            onClick={() => setActiveImage(img)}
          >
            <img src={img} alt={`Miniature ${index + 1}`} />
          </div>
        ))}
      </div>

      <style jsx>{`
        .game-gallery { display: flex; flex-direction: column; gap: 15px; margin: 20px 0; }
        .main-image-container { width: 100%; height: 450px; border-radius: 15px; overflow: hidden; border: 2px solid #333; }
        .main-image { width: 100%; height: 100%; object-fit: cover; transition: transform 0.3s ease; }
        .thumbnails-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)); gap: 10px; }
        .thumbnail { height: 70px; border-radius: 8px; overflow: hidden; cursor: pointer; border: 2px solid transparent; opacity: 0.6; transition: 0.3s; }
        .thumbnail:hover, .thumbnail.active { opacity: 1; border-color: #00ffcc; }
        .thumbnail img { width: 100%; height: 100%; object-fit: cover; }
      `}</style>
    </div>
  );
}

export default GameGallery;
